import { render, staticRenderFns } from "./install.vue?vue&type=template&id=b5f0963c&scoped=true"
import script from "./install.vue?vue&type=script&lang=js"
export * from "./install.vue?vue&type=script&lang=js"
import style0 from "./install.vue?vue&type=style&index=0&id=b5f0963c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f0963c",
  null
  
)

export default component.exports